/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1LocationCountriesDropdownQueryResponse,
  GetApiV1LocationCountriesDropdown401,
  GetApiV1LocationCountriesDropdown500,
} from "../../types/locationCountryController/GetApiV1LocationCountriesDropdown.ts";

function getGetApiV1LocationCountriesDropdownUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/location/countries/dropdown` as const,
  };
  return res;
}

/**
 * @description Retorna todos os países ativos, com nome resolvido pelo idioma configurado, ordenados alfabeticamente. **(Requer Authorization para autenticação)**
 * @summary Lista de países para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/dropdown}
 */
export async function getApiV1LocationCountriesDropdown(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1LocationCountriesDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1LocationCountriesDropdown401
      | GetApiV1LocationCountriesDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1LocationCountriesDropdownUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
